module.exports = __webpack_public_path__ + "img/home-left3.a1c7907d.png";